import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPages } from 'modules/CMS/reducers';

import Render from './CMSPage';

class CMSPage extends React.Component {
  static defaultProps = {
    match: { params: {} },
  };

  state = { pageId: null };

  componentDidMount () {
    const {
      slugs,
      getPages: getPageSlugs,
      match: { params: { pageSlug = this.props.slug } },
    } = this.props;

    if (!slugs) {
      getPageSlugs();
    } else if (slugs[pageSlug]) {
      this.setPageId(slugs[pageSlug].id);
    }
  }

  componentDidUpdate (prevProps) {
    const { match: { params: { pageSlug: nextSlug = this.props.slug } }, slugs = {} } = this.props;
    const { match: { params: { pageSlug: prevSlug = prevProps.slug } } } = prevProps;

    const { pageId } = this.state;
    const nextId = slugs[nextSlug] ? slugs[nextSlug].id : undefined;

    if (nextSlug !== prevSlug || pageId !== nextId) {
      this.setPageId(nextId);
    }
  }

  setPageId = pageId => this.setState({ pageId })

  render () {
    return <Render pageId={this.state.pageId} />;
  }
}

const mapStateToProps = state => ({
  slugs: state.CMS.slugs,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPages }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CMSPage);



// WEBPACK FOOTER //
// ./src/components/CMSPage/index.js